import React, { useEffect, useState, useContext, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import ContactGroup from '../ContactGroup';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { isBoatDetailsPageRedesign } from '../../../utils/newBDPHelper';
import { PortalConfigContext } from '../../../config/portal';
import { isInViewport } from '../../../utils/scrollHelper';
import './styles.css';

const StickyContact = (props) => {
  const [isHidden, setIsHidden] = useState(false);
  const context = useContext(PortalConfigContext);
  const activeBDPRedesign = isBoatDetailsPageRedesign(context);
  const lastScrollYRef = useRef(0);
  const scrollTimeoutRef = useRef(null);

  const handleContainerScroll = (event) => {
    const scrollContainer = event.target;
    const currentScrollY = scrollContainer.scrollTop;
    const isScrollingDown = currentScrollY > lastScrollYRef.current;

    setIsHidden(!!isScrollingDown);

    lastScrollYRef.current = currentScrollY;

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    scrollTimeoutRef.current = setTimeout(() => {
      setIsHidden(false);
    }, 200);
  };

  useEffect(() => {
    if (!activeBDPRedesign) {
      return;
    }

    window.addEventListener('scroll', handleScroll);
    const observer = new MutationObserver(() => {
      const scrollContainer = document.querySelector('.style-module_scrollGallery__Htlyd');
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', handleContainerScroll);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
      const scrollContainer = document.querySelector('.style-module_scrollGallery__Htlyd');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', handleContainerScroll);
      }
    };
  }, []);


const handleScroll = () => {
    const contactForm = document.querySelector('.email-lead-form');
    const appBannerElement = document.querySelector('.app-banner-top');
    if (applyStackedGalleryStyles) {
      setIsHidden(false);
      // eslint-disable-next-line no-unused-expressions
      appBannerElement?.style?.setProperty('bottom', '65px', 'important');
    } else {
      if (isInViewport(contactForm)) {
        setIsHidden(true);
        // eslint-disable-next-line no-unused-expressions
        appBannerElement?.style?.setProperty('bottom', '0px', 'important');
      } else {
        setIsHidden(false);
        // eslint-disable-next-line no-unused-expressions
        appBannerElement?.style?.setProperty('bottom', '65px', 'important');
      }
    }
  };

  const renderLoading = () => {
    return <LoadingPlaceholder type="text" />;
  };

  const renderContact = () => {
    return <ContactGroup {...props} />;
  };

  const isManufacturer = get(props, 'isManuFacturerForm', false);
  const { isLoading, isModalCarouselShown, breakpoint } = props;
  const largeMobileHorizontalWidth =
    typeof window !== 'undefined' && window.innerWidth >= 768 && window.innerWidth <= 932;
  const isLargeMobileLandscape = largeMobileHorizontalWidth && window.innerWidth > window.innerHeight;
  const isMobile = breakpoint === 'mobile';
  const showBtnsStackedGallery = isMobile || isLargeMobileLandscape;
  const applyStackedGalleryStyles = activeBDPRedesign && showBtnsStackedGallery && isModalCarouselShown;

  return (
    <div className={classnames('sticky-contact', {hidden: isHidden} , { 'sticky-contact-manufacturer': isManufacturer }, { 'stackedGallery': applyStackedGalleryStyles } )}>
      {isLoading
        ? renderLoading()
        : renderContact()}
    </div>
  );
};

StickyContact.defaultProps = {
  isLoading: false,
  isManufacturer: false,
};

StickyContact.propTypes = {
  isLoading: PropTypes.bool,
  listing: listingPropTypes,
  isManufacturer: PropTypes.bool,
  isManufacturerForm: PropTypes.bool,
  isModalCarouselShown: PropTypes.bool,
  breakpoint: PropTypes.string,
  onClickDealerLocator: PropTypes.func
};

export default memo(StickyContact);
